"use client"

import { Text } from "@/elements"
import { NovaWordmark } from "@/svg"
import { AppleLogo } from "@/svg/AppleLogo"
import clsx from "clsx"
import { useInView } from "motion/react"
import Link from "next/link"
import { RefObject, useRef } from "react"

export const MarketingFooter = () => {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref as RefObject<HTMLDivElement>)

  return (
    <>
      <div className="h-[1px] w-full" ref={ref} />
      <div className={clsx("sticky bottom-0 left-0 -mt-9 h-[570px] w-full", inView ? "opacity-100" : "opacity-0")}>
        <div
          className={clsx(
            "h-full w-full bg-marketing-primary-light text-marketing-background-1-light dark:bg-marketing-primary-dark dark:text-marketing-background-1-dark"
          )}>
          <div className="mx-auto hidden h-full max-w-[1280px] flex-col justify-between px-5 pb-[70px] pt-[155px] sm:flex sm:px-10">
            <div className="flex flex-row justify-between">
              <NovaWordmark
                className="fill-marketing-background-1-light dark:fill-marketing-background-1-dark"
                width={400}
                height={101}
              />
              <Link href="https://go.itsnova.com/appstore" className="h-min">
                <div className="flex flex-col gap-y-3">
                  <AppleLogo className="size-[26px] fill-marketing-background-1-light dark:fill-marketing-background-1-dark" />
                  <Text variant="CTASmall">Download the app</Text>
                </div>
              </Link>
            </div>
            <div className="flex flex-row flex-wrap gap-x-24">
              <div className="flex flex-col gap-y-1">
                <Text variant="CTASmall">@2024</Text>
                <Text variant="CTASmall">Los Angeles, CA</Text>
              </div>
              <div className="flex flex-col gap-y-1">
                <Text variant="CTASmall">
                  <Link href="/support">Help & Support</Link>
                </Text>

                <Text variant="CTASmall">
                  <Link href="/terms">Terms of Service</Link>
                </Text>
                <Text variant="CTASmall">
                  <Link href="/privacy-policy">Privacy Policy</Link>
                </Text>
                <Text variant="CTASmall">
                  <Link href="/faqs">FAQ</Link>
                </Text>
              </div>

              <Link href="https://instagram.com/itsnova" className="flex flex-col gap-y-1">
                <Text variant="CTASmall" className="text-marketing-secondary">
                  Instagram
                </Text>
                <Text variant="CTASmall" className="">
                  @itsnova
                </Text>
              </Link>
              <Link href="mailto:contact@itsnova.com" className="flex flex-col gap-y-1">
                <Text variant="CTASmall" className="text-marketing-secondary">
                  Email
                </Text>
                <Text variant="CTASmall" className="">
                  contact@itsnova.com
                </Text>
              </Link>
            </div>
          </div>

          <div className="mx-auto flex h-full max-w-[1280px] flex-col justify-between px-5 pb-[70px] pt-[155px] sm:hidden sm:px-10">
            <div className="flex flex-row justify-between">
              <NovaWordmark className="hidden sm:block" width={400} height={101} />
              <Link href="https://go.itsnova.com/appstore" className="h-min">
                <div className="flex flex-col gap-y-3">
                  <AppleLogo className="size-[26px] fill-marketing-background-1-light dark:fill-marketing-background-1-dark" />
                  <Text variant="CTASmall">Download the app</Text>
                </div>
              </Link>
            </div>
            <div className="flex flex-col flex-wrap justify-between gap-y-9 sm:flex-row">
              <div className="hidden flex-col gap-y-1 sm:flex">
                <Text variant="CTASmall">@2023 Nova</Text>
                <Text variant="CTASmall">Los Angeles, CA</Text>
              </div>
              <div className="flex flex-col gap-y-1">
                <Text variant="CTASmall">
                  <Link href="/support">Help & Support</Link>
                </Text>

                <Text variant="CTASmall">
                  <Link href="/terms">Terms of Service</Link>
                </Text>
                <Text variant="CTASmall">
                  <Link href="/privacy-policy">Privacy Policy</Link>
                </Text>
                <Text variant="CTASmall">
                  <Link href="/faqs">FAQ</Link>
                </Text>
              </div>

              <div className="grid grid-cols-2">
                <Link href="https://instagram.com/itsnova" className="flex h-fit flex-col gap-y-1">
                  <Text variant="CTASmall" className="text-marketing-secondary">
                    Instagram
                  </Text>
                  <Text variant="CTASmall" className="">
                    @itsnova
                  </Text>
                </Link>
                <Link href="mailto:contact@novantwrk.com" className="flex h-fit flex-col gap-y-1">
                  <Text variant="CTASmall" className="text-marketing-secondary">
                    Email
                  </Text>
                  <Text variant="CTASmall" className="">
                    contact@itsnova.com
                  </Text>
                </Link>
              </div>

              <div className="flex flex-col gap-y-1 sm:hidden">
                <Text variant="CTASmall">@2023 Nova</Text>
                <Text variant="CTASmall">Los Angeles, CA</Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
